export default __webpack_public_path__ + "static/media/MichaelLam.b6492bf1.jpeg";